import { FC, useEffect } from 'react'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import { useGetProjectByReferralCodeQuery } from '../../modules/missionControl/api'
import { useDispatch } from 'react-redux'
import {
  setReferralProjectData,
  setReferralProjectError,
  setReferralProjectLoading,
} from '../../modules/miscUi/actions'

interface MatchParams {
  code: string
}

const ReferralInvite: FC<RouteComponentProps<MatchParams>> = ({
  match: {
    params: { code },
  },
}) => {
  const { data, isLoading, isError } = useGetProjectByReferralCodeQuery({
    code,
  })
  const pool = data?.pool
  const drop = data?.drop
  const referral = data?.referral
  const task = data?.task

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setReferralProjectLoading(isLoading))
  }, [dispatch, isLoading])
  useEffect(() => {
    dispatch(setReferralProjectError(isError))
  }, [dispatch, isError])
  useEffect(() => {
    dispatch(setReferralProjectData({ pool, drop, referral, task }))
  }, [dispatch, drop, pool, referral, task])

  return (
    <>
      {!isLoading && !isError && (
        <>
          {pool ? (
            <Redirect to={`/fundraise/${pool.slug}`} />
          ) : drop ? (
            // <Redirect to={`/drops/${drop.slug}`} />
            <Redirect to={`/drops`} />
          ) : null}
        </>
      )}
    </>
  )
}

export default ReferralInvite
